// The frame every signed-out page shares (sign in, set a password, sign
// up): the ambient light, one card on a larger screen (full width on a
// phone), the logo, the heading, and the platform line under it. A
// step-by-step page (`steps`) is one width and held at a fixed height from
// the top, so the logo and the progress never move between its steps.

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { ambientLight } from "@/theme";

export function AuthFrame({
  title,
  above,
  children,
  steps,
}: {
  title: ReactNode;
  /** Over the heading, under the logo (the sign-up's progress). */
  above?: ReactNode;
  children: ReactNode;
  /** A page of several steps: 520px wide, anchored to the top instead of centred. */
  steps?: boolean;
}) {
  return (
    <div className="flex app-vh w-full flex-col items-center overflow-y-auto pt-safe pb-safe" style={{ background: ambientLight }}>
      <main className={cn("w-full px-4 py-12", steps ? "max-w-[520px] sm:mt-[10vh] sm:py-0 sm:pb-10" : "max-w-[432px] sm:my-auto sm:py-10")}>
        <div className="sm:rounded-card sm:border sm:border-line sm:bg-panel sm:p-8 sm:shadow-[var(--shadow-panel)]">
          <img src="/corvus-logo.svg" alt="Corvus Research" className="h-10 w-auto" />
          {above && <div className="mt-8">{above}</div>}
          <h1 className={cn("font-display text-2xl tracking-[var(--font-display-tracking)] text-fg", above ? "mt-3" : "mt-8")}>
            {title}
          </h1>
          {children}
        </div>
        <p className="mt-8 text-center text-xs text-fg-subtle">Corvus Agent Platform</p>
      </main>
    </div>
  );
}

/** The Google "G", from public/ (its own colours are Google's, not the theme's). */
export function GoogleMark({ className }: { className?: string }) {
  return <img src="/google-g.svg" alt="" aria-hidden className={cn("h-[18px] w-[18px] shrink-0", className)} />;
}
